var getStatusEventIcon =  function(val) {
    
    var createDiv = function(color, title){
        return `<div class="status-event" title="${title}"  style="background-color: ${color}"></div>`
    }

    switch (val) {
   
        case 1: return createDiv('#f54337', m['critical']);   
        case 2: return createDiv('#fec107', m['CriticalSerious']);    
        case 3: return createDiv('#909090', m['CriticalNoSerious']); 
        case 4: return createDiv('#2095f2', m['CriticalInformational']);
        case 5: return '';
        case -2: return '';
    }
    return '';

    
}

export default getStatusEventIcon;


// WEBPACK FOOTER //
// ./app/icon-status-event.js